<template>
    <!--<b-modal-->
    <!--    v-model="show_help_modal"-->
    <!--    scroll="clip"-->
    <!--    has-modal-card-->
    <!--    trap-focus-->
    <!--    can-cancel-->
    <!--    :destroy-on-hide="false"-->
    <!--    aria-role="dialog"-->
    <!--    aria-label="Help Modal"-->
    <!--    aria-modal>-->
        <div class="card general-modal help-modal" style="overflow-y: scroll; max-height: 80vh">
                <!--<div class="phoneinfo-container">-->
                <!--    <div class="numbers-container">-->
                <!--        <h2>Hai bisogno di aiuto?</h2>-->
                <!--        <p>Entre em contacto através dos seguintes números:</p>-->
                <!--        <a class="button next-button is-inverted" href="tel:808200146">808&nbsp;200&nbsp;146 rede&nbsp;fixa</a>-->
                <!--        <a class="button next-button is-inverted" href="tel:218410801">218&nbsp;410&nbsp;801 rede&nbsp;móvel</a>-->
                <!--        <p><strong>Horário de atendimento:</strong><br>dias úteis, das 9h às 18h</p>-->
                <!--    </div>-->
                <!--</div>-->
                <div class="collapse-container">
                    <h2>Ti serve aiuto?
                        Qui trovi tutte le risposte</h2>
                    <b-collapse class="card" animation="slide" :open="false" v-for="(drawer, index) in drawers" :key="index">
                        <template #trigger="props">
                            <div class="card-header" :class="{'card-header--active': props.open}"
                                 role="button"
                                 aria-controls="contentIdForA11y3">
                                <p class="card-header-title" v-html="drawer.title"></p>
                                <a class="card-header-icon">
                                    <b-icon :icon="props.open ? 'minus' : 'plus'"></b-icon>
                                </a>
                            </div>
                        </template>
                        <div class="card-content">
                            <div class="content" v-html="drawer.text"></div>
                        </div>
                    </b-collapse>
                </div>
            </div>
    <!--</b-modal>-->
</template>

<script>
import {sync} from "vuex-pathify";

export default {
    data() {
        return {
            drawers: [
                {
                    title: 'Il Pagamento online è sicuro?',
                    text: 'La tua sicurezza è una nostra priorità. I dati inseriti in questo sito (dati personali, dati bancari, carta di credito) vengono trasmessi con modalità sicura (SSL).',
                },
                {
                    title: 'È prevista la garanzia sul regalo di benvenuto?',
                    text: 'Si, tutti i prodotti presentati da YOUKADO sono coperti dalla garanzia del produttore (2 anni). Questa garanzia è inclusa nei prezzi di vendita, secondo la marca o il prodotto. I beneficiari devono conservare con cura la bolla di consegna che accompagna il loro pacco e funge da garanzia. La garanzia copre i pezzi di ricambio, i costi di manodopera e le spese di consegna o di restituzione dei prodotti. Il viaggio è coperto anche per i Prodotti difficili da trasportare (escluse le mini-macchine) come: lavatrici, asciugatrici, lavastoviglie, congelatori, frigoriferi, stufe, stufe, armadi per il vino, alcuni televisori (a seconda delle dimensioni). Nel caso in cui il regalo non sia riparabile, YOUKADO sostituirà il prodotto con un prodotto simile. Nel caso in cui il prodotto non esista più, o sarà sostituito da un prodotto equivalente (stesso tipo, stesso valore) o i punti saranno riaccreditati sul conto del Beneficiario senza alcuna penale. Nel caso in cui il prodotto non sia sostituibile, i punti utilizzati dal Beneficiario saranno riaccreditati sul conto del Beneficiario senza alcuno sconto.'
                },
                {
                    title: 'Come posso contattarvi?',
                    text:
                        'Chiama il numero <a href="tel:02668901">02668901</a> dal lunedì al venerdì dalle 9.00 alle 13.00 e dalle 14.00 alle 17.00'
                },
                {
                    title: 'Cosa ricevo oltre al regalo di benvenuto?',
                    text: 'Accesso illimitato ai contenuti del sito\n' +
                        '2€ per 2 mesi + 50% di sconto per 12 mesi\n' +
                        'Le riviste Altroconsumo Inchieste, Altroconsumo Intasca e Altroconsumo Insalute\n' +
                        'Consulenza legale telefonica gratuita'
                },
                {
                    title: 'Quanto costa l’iscrizione ad Altroconsumo?',
                    text: 'Per i primi 2 mesi di prova pagherai solo 2€. Al termine del periodo di prova usufruirai dello sconto di benvenuto del 50 % per 12 mesi: pagherai solo 25,65 € ogni trimestre (comprende anche la quota associativa di 3,85 €) anziché 51,30€. Riceverai la rivista mensile Altroconsumo Inchieste, il bimestrale InTasca e il bimestrale InSalute, diventerai socio di Altroconsumo e in più usufruirai di tutti i servizi e i vantaggi descritti in questo sito.\n' +
                        '\n'
                },
                {
                    title: 'Come devo fare per recedere?',
                    text: 'L’iscrizione ha validità immediata. Puoi decidere se esercitare o meno il diritto di recesso entro 15 giorni dalla data di sottoscrizione (come da DLgs n^ 206 del 6/09/2005). A maggior garanzia non sarà prelevato alcun importo prima dei 15 giorni dalla data di sottoscrizione. In caso di esercizio del diritto di recesso nulla sarà da te dovuto e tutte le spedizioni saranno immediatamente sospese. Le copie delle riviste eventualmente ricevute saranno tue in ogni caso, senza doverci nulla. Ti precisiamo anche che per rinunciare all\'iscrizione ad Altroconsumo ed esercitare il diritto di recesso basta semplicemente chiamare il numero 02 6961520 dalle 9 alle 13 e dalle 14 alle 17, dal lunedì al venerdì. Inoltre il diritto di recesso può essere esercitato collegandosi a Altroconsumo.it e cliccando sulla voce “contattaci” dove è possibile trovare il modulo predisposto.'
                },
                {
                    title: 'Quando viene spedito il regalo?',
                    text:'Il regalo di benvenuto ti verrà inviato entro 180 giorni dalla data di iscrizione, salvo verifica dei dati inseriti, e dopo l\'avvenuto pagamento della prima quota trimestrale scontata al 50%.'
                },
            ]
        }
    },
    computed: {
        show_help_modal: sync('func_data/show_help_modal'),
    }
}
</script>

<style scoped>

</style>
